// [NOTE] - This lib is pretty large, is there a better alternative?
import he from 'he'

export const decodeHtml = (html?: string) => {
  if (!html) return ''
  return he.decode(html)
}

export const decodeHTMLObject = (obj: unknown) => {
  if (obj === undefined || obj === null) {
    return obj;
  }

  if (typeof obj === 'string') {
    return he.decode(obj);
  } else if (Array.isArray(obj)) {
    return obj.map(item => decodeHTMLObject(item));
  } else if (typeof obj === 'object') {
    const decodedObj = {};
    for (const key of Object.keys(obj)) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        decodedObj[key] = decodeHTMLObject(obj[key]);
      }
    }
    return decodedObj;
  }
  return obj;
}

export function convertNumberToWords(number) {
  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  // eslint-disable-next-line max-len
  const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];

  if (number === 0) return 'zero';

  function convertLessThanThousand(num) {
    if (num < 10) return ones[num];
    if (num < 20) return teens[num - 10];
    if (num < 100) return tens[Math.floor(num / 10)] + ' ' + ones[num % 10];
    return ones[Math.floor(num / 100)] + ' hundred ' + convertLessThanThousand(num % 100);
  }

  let result = '';
  if (number >= 1000000000) {
    result += convertLessThanThousand(Math.floor(number / 1000000000)) + ' billion ';
    number %= 1000000000;
  }
  if (number >= 1000000) {
    result += convertLessThanThousand(Math.floor(number / 1000000)) + ' million ';
    number %= 1000000;
  }
  if (number >= 1000) {
    result += convertLessThanThousand(Math.floor(number / 1000)) + ' thousand ';
    number %= 1000;
  }
  if (number > 0) {
    result += convertLessThanThousand(number);
  }

  return result.trim();
}
